import React from 'react';
import { useDispatch } from 'react-redux';
import types from './types';
import UIInsetsProps from './UIInsetsProps';
import UIEditorSubcomponent from '../UIEditorSubcomponent';
import AssetUtility from '../../../classes/AssetUtility';
import UIRenderedCanvas from '../UIRenderedCanvas';
import { StoreActions } from '../../../state/store';
import Scenario from '../../../classes/scenarioElements/Scenario';
import { CustomEventTypes } from '../../../globals';
import TextVariables from '../../../classes/TextVariables';
import useForceUpdate from '../../reactUtils/useForceUpdate';
import useEventListener from '../../reactUtils/useEventListener';

export default function UIInsets(props)
{
	const forceUpdate = useForceUpdate();
	useEventListener(CustomEventTypes.hierarchyChangedEvent, () => forceUpdate(), document);

	const dispatch = useDispatch();
	const size = props.size ? props.size : 6;
	let properties = { ...UIInsetsProps({ size: size }) };

	if (props.context === 'editor')
	{
		return (
			<UIEditorSubcomponent
				title={'Insets'}
				subcomponent={types.INSETS}
				properties={properties}
				{...props}
			/>
		)
	}
	else if (props.data.visible)
	{
		const simulation = props.context === "simulation";
		const data = props.data;
		let insetCount = 1;
		while (data['inset ' + (insetCount + 1).toString() + ' type'])
		{
			insetCount++;
		}
		let insetsTop = [];
		let insetsMiddle = [];
		let insetsBottom = [];
		for (let i = 1; i <= insetCount; i++)
		{
			const keyStart = 'inset ' + i.toString() + ' ';
			const type = data[keyStart + 'type'].value;
			if (type !== 'invisible')
			{
				const imgAssetId = data[keyStart + 'image'].value;
				const cameraId = data[keyStart + 'camera'].value;

				if (imgAssetId || cameraId)
				{
					const imgUrl = AssetUtility.getPreviewAssetURL(imgAssetId);
					const videoAssetId = data[keyStart + 'video'].value;
					const videoUrl = AssetUtility.getPreviewAssetURL(videoAssetId);
					const audioAssetId = data[keyStart + 'audio'].value;
					const audioUrl = AssetUtility.getPreviewAssetURL(audioAssetId);
					const webUrl = data[keyStart + 'url'].value;
					const height = data[keyStart + 'height'].value;
					const link = data[keyStart + 'step'].value;
					const title = data[keyStart + 'title'].value ? TextVariables.textToData(data[keyStart + 'title'].value) : data[keyStart + 'title'].value;

					function onClick(e)
					{
						if (link && type === 'step' && Scenario.getStep(link))
						{
							Scenario.setCurrentStep(Scenario.getStep(link));
						}
						else if (videoAssetId && type === 'video')
						{
							dispatch(StoreActions.ui.showVideoPlayer({
								visible: true,
								url: videoUrl
							}))
						}
						else if(audioAssetId && type === 'audio')
						{
							dispatch(StoreActions.ui.showVideoPlayer({
								visible: true,
								url: audioUrl,
								audioOnly: true,
							}))
						}
						else if (webUrl && type === 'url')
						{
							window.open(webUrl, '_blank');
						}
					}

					// calculate className
					let className = "inset-" + type + "-middle";
					if (data[keyStart + 'anchor'].value.includes("left"))
						className = "inset-" + type + "-left";
					else if (data[keyStart + 'anchor'].value.includes("right"))
						className = "inset-" + type + "-right";

					if (simulation)
						className += "-simulation";

					// calculate parent
					let parent = insetsMiddle;
					if (data[keyStart + 'anchor'].value.includes("top"))
						parent = insetsTop;
					else if (data[keyStart + 'anchor'].value.includes("bottom"))
						parent = insetsBottom;

					if (type === 'camera')
					{
						parent.push(
							<UIRenderedCanvas
								context={props.context}
								cameraId={cameraId}
								className={className}
								onClick={onClick}
								height={height}
								title={title}
								key={i}
								draggable={false}
								// zIndex={i * 1000}
							/>
						);
					}
					else
					{ //redner an image
						parent.push(
							<img
								className={className}
								onClick={onClick}
								src={imgUrl}
								key={i}
								draggable={false}
								style={{maxHeight: height + '%'}} //zIndex: i * 1000
							/>
						);
					}
				}
			}
		}

		return (
			<div className='uiInsetsRoot'
				data-name={"ui-insets-root"}
			>
				<div className='uiInsetsRow'
					data-name={"ui-insets-row-top"}
				>
					{insetsTop}
				</div>
				<div className='uiInsetsRow'
					data-name={"ui-insets-row-middle"}
				>
					{insetsMiddle}
				</div>
				<div className='uiInsetsRow'
					data-name={"ui-insets-row-bottom"}
				>
					{insetsBottom}
				</div>
			</div>
		);
	}

	return null;
}